import React from 'react';
import { useFormikContext } from 'formik';
import { MdLockOutline } from 'react-icons/md';

import Toggle from '../form/Toggle';
import InfoTooltip from './InfoTooltip';

const PrivateToggle = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const togglePrivacy = () => {
    setFieldValue('private', !values.private);
  };

  return (
    <div className="w-full mr-10 pt-6 text-base text-gray-500 flex items-center justify-between">
      <div className="flex items-center">
        <MdLockOutline size={20} className="mr-2" /> Private event
        <InfoTooltip
          id="private-event-tooltip"
          message="If an event is private, no one will be able to see or join your event unless you have personally invited them."
        />
      </div>

      <Toggle isActive={values.private} onClick={togglePrivacy} />
    </div>
  );
};

export default PrivateToggle;
